export enum Roles {
  user = 'user',
  admin = 'admin',
}

export enum ClientRole {
  admin = 'admin',
  manager = 'manager',
  member = 'member',
}
